import { DotsThreeOutlineIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MenuBulletHorizontal = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <DotsThreeOutlineIcon fill={fill} {...rest} size={Sizes[size]} />;
};

MenuBulletHorizontal.displayName = 'MenuBulletHorizontal';
